<template>
  <b-dropdown
    no-caret
    size="sm"
    variant="link"
    class="float-right"
  >
    <template #button-content>
      <b-icon icon="three-dots-vertical" font-scale="1.2" />
    </template>

    <b-dropdown-item @click="onIpDetailsReroute">
      IP Details
    </b-dropdown-item>
    <PcapDownload
      v-if="showPcapDownloadOption"
      :xomeId="xomeId"
      :ip="ip"
      :timeRange="timeRange"
      class="w-100"
    />
  </b-dropdown>
</template>

<script>
import PcapDownload from '@/xvisor/components/PcapDownload.vue';

export default {
  name: 'MoreActions',
  props: {
    xomeId: {
      type: Number,
      required: true,
    },
    ip: {
      type: String,
      required: true,
    },
    timeRange: {
      type: Object,
      required: true,
    },
    showPcapDownloadOption: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PcapDownload,
  },
  methods: {
    navigateTo() {
      this.$router.push({
        name: 'ipattrs',
        params: {
          ip: this.ip,
        },
      });
    },
    onIpDetailsReroute() {
      this.navigateTo();
    },
  },
};
</script>
